import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

export const ChildNotAvailable = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <p className={clsx(s.title, 'bold-17')}>
        {t('beket.child_not_avaliable_title')}
      </p>

      <div className={s.flex}>
        <AppIcon
          width={15}
          height={15}
          className={s.infoIcon}
          id={AllIcons.INFO_ROUNDED}
        />
        <p className={clsx(s.text, 'regular-12')}>
          {t('beket.child_not_avaliable')}
        </p>
      </div>
    </div>
  )
}
